import { getRole } from "~/features/common/utils/loginChecks";
import { featuresAndRoutesFromSidebarArray, type FlattenedSideBarRouteObject } from "./getFeatureRoutesFromSidebar";

export const getFallBackRouteMatch = (currentRoute: FlattenedSideBarRouteObject) => {
  const myRole = getRole();

  if (!myRole) return undefined;

  const navCategoryParent = featuresAndRoutesFromSidebarArray?.find(route => route.baseURL === currentRoute.baseURL);

  if (!navCategoryParent) return undefined;

  const fallBack = navCategoryParent.children?.find(child => child.restrictToRoles?.includes(myRole));

  return fallBack?.link;
};
